<template>
  <div class="navcontainer">
    <div class="logobox"></div>
    <el-menu
      :default-active="activeIndex"
      class="el-menu-demo"
      mode="horizontal"
      @select="handleSelect"
    >
      <el-menu-item index="1"
        ><RouterLink to="/aboutus">关于我们</RouterLink></el-menu-item
      >
      <el-menu-item index="2"><router-link to = "/products">主要产品</router-link></el-menu-item>
      <el-menu-item index="3"><router-link to = "/article">新闻中心</router-link></el-menu-item>
      <el-menu-item index="4"><router-link to = "/contactus">联系我们</router-link></el-menu-item>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: "SiteNav",
};
</script>

<style>
.el-menu-demo {
  float: right;
}
.navcontainer {
  width: 1200px;
  /*background-color: green;*/
  height: 60px;
  margin-top: -60px;
  margin-left: auto;
  margin-right: auto;
}
.el-menu.el-menu--horizontal {
  margin-top: -60px;
  /*
  */
  font-size: unset;
}
.el-menu-item {
  font-size: 16px !important;
}
.logobox {
  background-image: url("../assets/logo123.png");
  height: 60px;
  width: 60px;
  /*background-color: black;*/
}
</style>